// The mails the backend sends the staff about the kiosks and partner requests, by
// their keys in its utils/alerts.js, in the order the Settings page shows them
export const ALERTS = [
	{
		key: "paper",
		name: "A4 цаас цөөрсөн",
		text: "A4 цаасны үлдэгдэл сануулгын тоонд хүрсэн киоскоос хэвлэлт бүрийн дараа явна.",
		icon: "fa-file-alt",
		tint: "text-yellow-600 bg-yellow-100 dark:text-yellow-100 dark:bg-yellow-700",
	},
	{
		key: "rearTray",
		name: "Rear tray-ийн цаас цөөрсөн",
		text: "Rear tray-ийн зургийн цаас сануулгын тоонд хүрэхэд нэг удаа явна.",
		icon: "fa-image",
		tint: "text-yellow-600 bg-yellow-100 dark:text-yellow-100 dark:bg-yellow-700",
	},
	{
		key: "printError",
		name: "Хэвлэлтийн алдаа",
		text: "Киоск хэвлэж чадаагүй эсвэл төлбөрийн өмнө алдаа гарахад, буцаалтын мэдээлэлтэй явна.",
		icon: "fa-exclamation-triangle",
		tint: "text-red-600 bg-red-100 dark:text-red-100 dark:bg-red-700",
	},
	{
		key: "outage",
		name: "Киоскийн үйлчилгээ зогссон",
		text: "Киоск холбогдсон хэвээр ч 15 минутаас удаан хэвлэх боломжгүй байвал (принтерийн алдаа, түгжээ, цаас дууссан) нэг удаа, дахин ажиллах хүртэл.",
		icon: "fa-pause-circle",
		tint: "text-red-600 bg-red-100 dark:text-red-100 dark:bg-red-700",
	},
	{
		key: "offline",
		name: "Киоск холбогдохгүй",
		text: "Киоск сервертэй холбогдохоо больсон үед нэг удаа, дахин холбогдох хүртэл.",
		icon: "fa-plug",
		tint: "text-gray-600 bg-gray-200 dark:text-gray-200 dark:bg-gray-600",
	},
	{
		key: "partner",
		name: "Хамтран ажиллах хүсэлт",
		text: "cloudprint.mn-ийн реклам, киоск байршуулах, киоск худалдаж авах хуудаснаас хүсэлт ирэх бүрд явна.",
		icon: "fa-handshake",
		tint: "text-blue-600 bg-blue-100 dark:text-blue-100 dark:bg-blue-700",
	},
];

// The same limits as the backend's utils/alerts.js and utils/rearTray.js
export const PAPER_LOW_MAX = 5000;
export const REAR_TRAY_LOW_MAX = 100;
export const MAX_RECIPIENTS = 20;

const EMAIL_RE = /^[^\s@,;<>"]+@[^\s@,;<>"]+\.[^\s@,;<>"]+$/;
export const isEmail = (value) => EMAIL_RE.test(value);
